import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Fields from 'redux/Fields';
import Notifications from 'redux/Notifications';

const useFields = () => {
  const dispatch = useDispatch();

  const isFetchingFields = useSelector(Fields.isFetchingFields);

  const fields = useSelector(Fields.getFields);
  const activeFields = useSelector(Fields.getActiveFields);
  const selectedField = useSelector(Fields.getActiveFieldObject);
  const selectedFieldId = useSelector(Fields.getActiveFieldId);
  const fieldBounds = useSelector(Fields.getFieldsBounds);
  const fieldCenter = useSelector(Fields.getFieldsCenter);
  const geometryLoad = useSelector(Fields.getGeometryLoad);

  const setGeometryLoad = (loaded) => {
    return dispatch(Fields.setGeometryLoad(loaded));
  };

  const fetchFields = (propertyId, organizationId) => {
    if (!isFetchingFields) {
      dispatch(Fields.startFetchFields());
      return dispatch(Fields.fetchFields(propertyId, organizationId)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const fetchField = (fieldId) => {
    dispatch(Fields.startFetchFields());
    return dispatch(Fields.fetchField(fieldId)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  const setSelectedField = (fieldId) => {
    return dispatch(Fields.setSelectedField(fieldId));
  };

  const getFieldUpdateTime = (field) => {
    return moment(field.updated_at).unix();
  };

  const saveField = (field) => {
    if (field.id) {
      return dispatch(Fields.saveField(field)).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    } else {
      let array = new Uint32Array(10);
      let id = window.crypto.getRandomValues(array).toString();
      dispatch(Fields.insertFields(field.property_id, { ...field, id })).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const deleteField = (fieldId) => {
    dispatch(Fields.deleteField(fieldId)).catch((err) => {
      dispatch(Notifications.setError(err));
    });
  };

  return {
    fields,
    activeFields,
    selectedField,
    selectedFieldId,
    fieldBounds,
    fieldCenter,
    geometryLoad,

    saveField,
    deleteField,
    setSelectedField,
    getFieldUpdateTime,
    fetchFields,
    fetchField,
    setGeometryLoad,
    isFetchingFields,
  };
};

export default useFields;
